/* tslint:disable:jsx-no-lambda WI:47696 */
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { logUsage } from 'owa-analytics';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';
import clickGetStartedTask from '../actions/clickGetStartedTask';
import { getStore } from '../store/store';
import { GetStartedTaskProperty } from '../interfaces/GetStartedTaskProperty';
import { GetStartedTaskStatus } from '../enums/GetStartedTaskStatus';
import TaskButton from './TaskButton';

const styles = require('./GetStartedTask.scss');

export interface GetStartedTaskState {
    hovered: boolean;
}

@observer
export default class GetStartedTask extends React.Component<
    GetStartedTaskProperty,
    GetStartedTaskState
> {
    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
        };
    }

    componentDidMount() {
        if (this.props.identity in getStore().tasks) {
            logUsage('GetStartedTaskShown', [this.props.identity, this.isCompleted], {
                isCore: true,
            });
        }
    }

    private get isCompleted(): boolean {
        return getStore().tasks[this.props.identity].status === GetStartedTaskStatus.Completed;
    }

    private get isVisible(): boolean {
        return !this.isCompleted || (this.isCompleted && !this.props.hideCompleted);
    }

    private onClick = (evt: React.MouseEvent<unknown>): void => {
        if (this.props.onClick) {
            clickGetStartedTask(this.props.identity, this.props.listPosition);
            this.props.onClick();
        }
    };

    private onMouseEnter = (evt: React.MouseEvent<unknown>): void => {
        this.setState({ hovered: true });
    };

    private onMouseLeave = (evt: React.MouseEvent<unknown>): void => {
        this.setState({ hovered: false });
    };

    private getTailIconSection(): JSX.Element {
        if (this.isCompleted) {
            return <Icon className={styles.completedIcon} iconName={ControlIcons.CompletedSolid} />;
        }

        return undefined;
    }

    render() {
        return (
            this.props.identity in getStore().tasks && (
                <TaskButton
                    identity={this.props.identity}
                    completed={this.isCompleted}
                    visible={this.isVisible}
                    listPosition={this.props.listPosition}
                    onClick={this.onClick}
                    onMouseEnter={this.onMouseEnter}
                    onMouseLeave={this.onMouseLeave}
                    headIconSection={<Icon iconName={this.props.icon} />}
                    tailIconSection={this.getTailIconSection()}
                    buttonTextSection={<div>{this.props.text}</div>}
                />
            )
        );
    }
}
